import React, { FC } from 'react';
import { UIIcon } from '../UIIcon/UIIcon';
import './icons.scss';

export const AnswerIcon: FC<{ size?: number }> = ({ size }) => (
  <UIIcon className="answerIcon" name="answer" size={size} />
);
